import {
  LOAD_TRIPTEMPERATURE,

} from "./actions";

const initialState = {
  triptemperatureUrl: "",

  triptemperatureLoading: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOAD_TRIPTEMPERATURE.REQUEST:
      const { loading } = action.payload;
      return {
        ...state,
        triptemperatureLoading: loading
      };
    case LOAD_TRIPTEMPERATURE.SUCCESS:

      return {
        ...state,
        triptemperaturekUrl: action.payload.data.data,
        triptemperatureLoading: false
      };
    default:
      return state;
  }
};
